jQuery(function($) {
	$('.eurotools-auto-iframe').EurolandIFrameAutoHeight();
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/iframe.js
// module id = 21
// module chunks = 0